import React from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';

const CustomPageDetailContentManufacturerMiddleLayoutItem = (props) => {

  let {
    pageBlockItem,
    columns,
    columnsSp
  } = props;

  const getColClass = () => {
    let col_class;
    switch(parseInt(columns)) {
      case 1:
        col_class = 'col-md-12';
        break;
      case 2:
        col_class = 'col-md-6';
        break;
      case 3:
        col_class = 'col-md-4';
        break;
      case 4:
        col_class = 'col-md-3';
        break;
      case 5:
        col_class = 'col-md-2-5';
        break;
      case 6:
        col_class = 'col-md-2';
        break;
      default:
        col_class = 'col-md';
        break;
    }
    switch(parseInt(columnsSp)) {
      case 1:
        col_class += ' col-sm-12 col-12';
        break;
      case 2:
        col_class += ' col-sm-6 col-6';
        break;
      case 3:
        col_class += ' col-sm-4 col-4';
        break;
      case 4:
        col_class += ' col-sm-3 col-3';
        break;
      case 5:
        col_class += ' col-sm-2-5 col-2-5';
        break;
      case 6:
        col_class += ' col-sm-2 col-2';
        break;
      default:
        col_class += ' col-sm col';
        break;
    }
    return col_class;
  };

  return (
    <li className={clsx('product-item flex-column align-items-stretch',getColClass())}>
      <div className="img" data-mh="mh_01">
        <a href={pageBlockItem.itemUrl}>
          <span>
            <img className="m_imgShadow" src={pageBlockItem.itemImageUrl} />
          </span>
        </a>
      </div>
      <div className="dtl" data-mh="mh_02">
        <p className="ttl"><span><a target="_blank" href={pageBlockItem.itemUrl}>{pageBlockItem.itemName}</a></span></p>
        {pageBlockItem.extendProperties.modelNumber && <p className="subTxt">{pageBlockItem.extendProperties.modelNumber}</p>}
        <p className="subTxt"><a href={pageBlockItem.extendProperties.itemCompanyUrl}>{pageBlockItem.extendProperties.itemCompanyName}</a></p>
        <p className="label">{pageBlockItem.itemCategoryName}</p>
      </div>
    </li>
  );
};

CustomPageDetailContentManufacturerMiddleLayoutItem.propTypes = {
  pageBlockItem: PropTypes.any.isRequired,
  columns: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  columnsSp: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
};

export default CustomPageDetailContentManufacturerMiddleLayoutItem;
